import i18next from 'i18next';

i18next.addResources('es_CL', 'OrderData', {
  title: 'Datos de tu orden',
  paymentMethod: 'Método de pago:',
  dateOfPurchase: 'Fecha y hora de compra:',
  store: 'Tienda:',
  storePhone: 'Teléfono de la tienda:'
});
